
import { Vue, Component, Prop } from "vue-property-decorator";
import CIVueSlider from "@components/plugins/vue-slider.vue";
import Wrapper from "../forms/wrapper.vue";
import VSelect from "@components/plugins/vue-select.vue";
import { Period } from "@models/enums";
import { Emitter } from "@utils/events";

@Component({
  name: "ci-ais-range-with-period",
  components: {
    "ci-vue-slider": CIVueSlider,
    "ci-fe-wrapper": Wrapper,
    VSelect,
  },
})
export default class extends Vue {
  @Prop({ default: "" }) public label!: string;
  @Prop({ default: () => [] }) options!: (Period | string)[];
  @Prop({ required: true }) public attribute!: string;
  @Prop({ default: null }) min!: Nullable<number>;
  @Prop({ default: null }) max!: Nullable<number>;

  private value: string = "";

  public get hasOptions(): boolean {
    return this.options.length > 0;
  }

  public get concatenatedAttribute(): string {
    if (this.options.length > 0) {
      return !this.value ? "" : `${this.attribute}${this.value}`;
    } else {
      return this.attribute;
    }
  }

  public get translatedOptions(): (Indexable<string> | string)[] {
    return this.options.map((option) =>
      option
        ? {
            key: option,
            value: option,
            label: this.$t(`products.periods.${option}`) as string,
          }
        : option
    );
  }

  public toValue(value: Indexable, range: Indexable): ExplicitAny {
    const min = typeof value.min === "number" ? (value.min >= range.min ? value.min : range.min) : range.min;
    const max = typeof value.max === "number" ? (value.max <= range.max ? value.max : range.max) : range.max;
    return [min, max];
  }

  public formatMinValue(minValue: Nullable<number>, minRange: number): any {
    return minValue !== null && minValue > minRange ? minValue : minRange || "";
  }

  public formatMaxValue(maxValue: Nullable<number>, maxRange: number): any {
    return maxValue !== null && maxValue < maxRange ? maxValue : maxRange || "";
  }

  public created(): void {
    this.setValueFromRoute();
    Emitter.on("ci::clear-refinement::ais", () => {
      this.value = "";
    });

    window.addEventListener("popstate", () => {
      setTimeout(() => this.setValueFromRoute(), 50);
    });
  }

  private setValueFromRoute(): void {
    const componentRoute = this.$route;
    if (componentRoute?.query && this.attribute) {
      const rangeOptions = Object.keys(componentRoute.query).filter((k) => k.includes("range"));
      const rangeOptionForAttribute = rangeOptions.find((k) => k.includes(this.attribute));
      if (rangeOptions.length > 0 && rangeOptionForAttribute) {
        const selectedRange = rangeOptionForAttribute.split(this.attribute)[1].replace("]", "");
        this.value = selectedRange;
      }
    }
  }
}
